import React from 'react';
import { Navigate, useLocation } from 'react-router';
import useAuth from 'contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const {
    state: { currentUser },
  } = useAuth();
  
  const from = location.pathname !== '/logout' ? `?from=${location.pathname}` : '';
  
  return currentUser ? (
    children
  ) : (
    <Navigate to={`/login${from}`} replace state={{ from: location }} />
  );
};

export default PrivateRoute;